import React from 'react';

import { Helmet } from 'react-helmet';

import PricingToolPage from '~/components/PricingTool/PricingToolPage';

export default function OfferBuilderPricingToolPage() {
  return (
    <>
      <Helmet>
        <title>Hotel Proposal Pricing Tool | Offer Builder</title>
      </Helmet>

      <PricingToolPage />
    </>
  );
}
